module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.sms.do_you_want_to_delete_the_template')) + "?")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.editsms.title))]), _vm._v(" "), _c('p', {
    staticClass: "marg-1-bottom"
  }, [_c('i', [_vm._v(_vm._s(_vm.editsms.body))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn marg-10-right",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-danger",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc2e04b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/MedssageTemplateDelete.vue
// module id = 2108
// module chunks = 1